import { render, staticRenderFns } from "./HomePartners.vue?vue&type=template&id=6f85139c&"
import script from "./HomePartners.vue?vue&type=script&lang=js&"
export * from "./HomePartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports